
/**
 * Created by satans17 on 2017/1/8.
 */
import util from '../../lib/util';

function formatUserInfo(userInfo = {}) {
  const {
    birth,
    corpId,
    gender,
    isFirstVisit,
    lastVisitTime,
    memberType,
    nick,
    phone,
    todayIsBirthDay,
    userId,
  } = userInfo;
  return {
    // 生日 yyyymmdd
    birth,
    // 今天是否是用户的生日
    todayIsBirthDay,
    // ?
    corpId,
    // 性别 m/f
    gender,
    // 是否首次访问
    isFirstVisit,
    // 最后一次访问时间
    lastVisitTime,
    // 用户类型 normal/alicare
    memberType,
    // nick
    nick,
    // 电话号码
    phone,
    // userId
    userId,
  };
}


function formatSession(data) {
  const session = data.session || {};
  const {
    isInQueue = {},
    queuing,
    servicerGroupId,
    servicerUserId,
    p2pTimestamp,
    p2pToken,
    resumeSid,
    sessionId,
    sid,
    toId,
    token,
    vendor,
  } = session.data || {};
  return {
    actionTips: data.actionTips,
    openToken: data.openToken,
    openbaseType: data.config.openbaseType,
    connect: data.connect,
    xcode: data.xcode,
    timestemp: data.time,
    continuedResume: session.continuedResume,
    isNeedResume: session.isNeedResume,
    isInQueue,
    queuing,
    servicerGroupId,
    servicerUserId,
    resumeSid,
    p2pToken,
    p2pTimestamp,
    sessionId,
    sid,
    toId,
    token,
    vendor,
  };
}

function formatBase(data) {
  return {
    // imsid
    imsid: data.imsid,
    // 来源  unknow
    from: data.from,
    // sourceId
    sourceId: data.sourceId,
    appName: data.config.appName || 'alixm',
    // 当前运行环境
    env: data.env,
    // 知识点bu
    bu: data.bu,
  };
}

function formatRobot(data) {
  return {
    botId: data.botId,
    robotCode: data.robotCode,
    robotScene: data.robotScene,
  };
}

function formatAppConfig(data) {
  const {
    autoWord,
    greetings,
    inputTip,
    inputType,
    logo,
    openbaseType,
    shortcuts,
    toApassManager,
    welcomeMsg,
    appName,
    customSmiley,
    defaultManualAvatar,
    theme,
    robotAvatar,
  } = data.config;
  return {
    autoWord,
    greetings,
    inputTip,
    inputType,
    logo,
    openbaseType,
    shortcuts,
    toApassManager,
    // 欢迎语
    welcomeMsg,
    // 默认人工头像
    defaultManualAvatar,
    // 主题
    theme,
    // 自定义表情
    customSmiley: customSmiley || [],
    // 存历史消息用，没有则默认为alixm
    appName: appName || 'alixm',
    // 当前皮肤
    skin: data.skin || 'normal',
    // 功能开关
    switch: data.switch,
    // 默认插件
    pluginVersion: data.pluginVersion,
    // ?
    actionTips: data.actionTips,
    // 机器人头像配置，用在顶部头像和机器人名片
    robotAvatar,
  };
}

function formatBUConfig() {
  return {
    customization: null,
  };
}

function dataMap(data) {
  const r = new Map();
  // 应用核心配置
  r.set('base', formatBase(data));
  // url querystring
  r.set('qs', util.queryString.parse(location.search.replace(/^\?/, '')));
  // 用户信息
  r.set('user', formatUserInfo(data.user));
  // 会话相关
  r.set('ocs', formatSession(data));
  // 机器人相关
  r.set('robot', formatRobot(data));
  // 应用配置
  r.set('appConfig', formatAppConfig(data));
  // BU 配置，新的实例
  r.set('bu', formatBUConfig(data));
  // 首问语
  r.set('recommend', {
    banner: data.config.banner,
    list: data.config.recommend,
  });
  // 导购
  r.set('easygo', data.easygo);
  // 公告
  r.set('announcements', data.announcements);
  // 历史消息
  r.set('history', data.history);
  // 消息盒子
  r.set('msgbox', data.msgbox);
  r.set('onedata', data.onedata);
  r.set('switches', data.switch);
  r.set('prime', data.prime);
  r.set('remind', data.remind);
  r.set('messages', data.messages);
  r.set('redirector', data.redirector);
  // +号里的插件配置
  r.set('plugin', data.plugin);

  return r;
}

/**
 * 格式化后端配置
 */
function appConfigFormat(data) {
  util.storage.setItem('lastConfig', JSON.stringify(data));
  return dataMap(data);
}


/**
 * 格式化默认默认配置
 * TODO，兜底逻辑
 */
function appConfigDefault() {
  if (util.storage.getItem('lastConfig')) {
    return dataMap(JSON.parse(util.storage.getItem('lastConfig')));
  }
  const qs = util.queryString.parse(location.search.replace(/^\?/, ''));
  const data = {
    robotCode: 'alicare_new',
    robotScene: 'alicare_new_scene',
    sourceId: '1506162234',
    imsid: new Date().getTime(),
    session: {
      resume: false,
    },
    qs,
    announcements: [],
    from: qs.from || 'unknow',
    recommend: null,
    history: [],
    user: {},
    config: {
      welcomeMsg: util.lang.get('WELCOME:MESSAGE'),
    },
    switch: {
      hideCommentManualEntrance: true,
      knowledgeToManual: {
        enable: false,
      },
    },
  };
  return dataMap(data);
}

export { appConfigFormat, appConfigDefault };



// WEBPACK FOOTER //
// ./src/app/model/formatappconfig.js